import styled, { css } from 'styled-components';
import { Label } from '../TypographyNew';

export const TextAreaContainer = styled.div`
  width: 100%;
`;

export const StyledTextArea = styled.div`
  padding: var(--spacing-m) var(--spacing-s) var(--spacing-s);
  background: var(--color-interface-neutral-light);
  color: var(--color-interface-content-lighter);
  border: 1px solid var(--color-interface-layout-normal);
  border-radius: var(--radius-8);
  resize: vertical;
  overflow: auto;
  position: relative;
  display: flex;
  width: 100%;
  gap: var(--spacing-s);

  > svg {
    flex-shrink: 0;

    &:last-child {
      align-self: end;
    }
  }

  > textarea {
    border: unset;
    resize: none;
    outline: 0;
    width: 100%;
    font-family: 'DM Sans', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    margin: unset;
    padding: unset;
    color: inherit;

    &::placeholder {
      color: var(--color-interface-content-lighter);
    }

    &:disabled {
      background: unset;
      color: var(--color-interface-layout-darkest);

      &::placeholder {
        color: inherit;
      }
    }
  }

  &:focus-within,
  &:hover {
    color: var(--color-interface-content-normal);
    border-color: var(--color-interface-secondary-normal);
  }

  // Text area  filled > change the color of the container items
  :has(textarea:not(:placeholder-shown)) {
    color: var(--color-interface-content-normal);
  }

  // Text area disabled > change the color of the container items
  :has(textarea:disabled) {
    color: var(--color-interface-layout-darkest);
    border: 1px solid var(--color-interface-layout-normal);
  }

  // Remove the default resize icon
  &::-webkit-resizer {
    display: none;
  }
`;

export const CharCountLabel = styled(Label).attrs({ variant: 2 })<{
  disabled?: boolean;
}>`
  text-align: end;
  margin-top: calc(var(--spacing-xxs) * 2);
  ${(p) =>
    p.disabled &&
    css`
      color: var(--color-interface-content-lightest);
    `}
`;
